export default "__VITE_ASSET__D36Zu8dk__"